import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=5346c43c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=5346c43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5346c43c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5346c43c')) {
      api.createRecord('5346c43c', component.options)
    } else {
      api.reload('5346c43c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=5346c43c&scoped=true&", function () {
      api.rerender('5346c43c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2My6bZ5o4m28f/JS/comp/SearchFilterTokens.vue"
export default component.exports